/*------------------------------------*\
    FEEDBACK REVIEW
\*------------------------------------*/
import Bugsnag from "@bugsnag/js";
import Cookies from 'js-cookie';

const consultation = require("../../site/_data/consultation");

const axios = require('axios');

const FormData = require('form-data');
const formData = new FormData();

if (process.env.BUGSNAG_API_KEY) {
    Bugsnag.start({
        apiKey: process.env.BUGSNAG_API_KEY,
        releaseStage: process.env.RELEASE_ENV,
    });
}

class FeedbackReview {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.requiredFields = self.elem.querySelector('[data-required-fields]');
        self.feedbackReady = self.elem.querySelector('[data-feedback-ready]');
        self.formErrors = self.elem.querySelector('[data-form-error]');
        
        // Feedback submit button
        self.feedbackDefault = self.elem.querySelector('[data-feedback-default]');
        self.feedbackSubmitting = self.elem.querySelector('[data-feedback-submitting]');

        // Cookie confirmation
        self.cookiesPending = self.elem.querySelector('[data-cookies-pending]');
        self.cookiesConfirmed = self.elem.querySelector('[data-cookies-confirmed]');
    }

    init() {
        let self = this;

        self.checkCookiesConfirmed();
        self.populateHiddenFields();
        self.checkRequiredFields();
        self.submit();
    }

    checkCookiesConfirmed() {
        let self = this;

        let confirmed = Cookies.get(process.env.COOKIE_NAME);

        if (confirmed) {
            self.cookiesPending.classList.add('d-none');
            self.cookiesConfirmed.classList.remove('d-none');
        } else {
            self.cookiesPending.classList.remove('d-none');
            self.cookiesConfirmed.classList.add('d-none');
        }
    }

    checkRequiredFields() {
        let self = this;

        // Check if user's personal details are complete
        if (!localStorage.getItem(consultation.contact_slug)) {
            self.requiredFields.classList.remove("d-none");
            self.feedbackReady.classList.add("d-none");
        }
    }

    populateHiddenFields() {
        let self = this;

        // Get all item from local storage
        let fields = self.getLocalStorage();

        fields.sort(function(a, b){
            if(a.name < b.name) {
                return -1;
            }

            if(a.name > b.name) {
                return 1;
            }

            return 0;
        });

        // Loop through the items
        fields.forEach(field => {
            // Create the markup for a hidden input
            let markup = document.createElement('input');

            markup.setAttribute('type', 'hidden');
            markup.setAttribute('name', field.name);
            markup.setAttribute('value', field.value);

            self.elem.append(markup);
        });
    }

    // Get all items from local storage and convert to array
    // containing an object for each item
    getLocalStorage() {
        let self = this;

        let archive = [],
            keys = Object.keys(localStorage),
            i = 0,
            key;

        // Accept question data from local storage only. 
        // Prevents extension keys from interfering with feedback data
        for (; (key = keys[i]); i++) {
            
            consultation.sections.forEach((section) => {
                if (section.slug !== consultation.contact_slug) {
                    section.sub_sections.forEach((sub_section) => {
                        sub_section.groups.forEach((group) => {
                            group.questions.forEach((question) => {
                                self.buildStoredKey(archive, key, question);
                            })
                        });
                    });    
                } else {
                    section.questions.forEach((question) => {
                        self.buildStoredKey(archive, key, question);
                    });
                }
            });
        }

        return archive;
    }

    buildStoredKey(archive, key, question) {
        if (key.includes(question.name)) {
            let data = JSON.parse(localStorage.getItem(key));

            if (data) {
                archive.push({
                    name: key,
                    label: data.label,
                    value: data.value,
                });
            }
        }
    }

    submit() {
        let self = this;

        // When the form submit button is clicked...
        self.elem.addEventListener("submit", (evt) => {
            // Prevent the form from submitting
            evt.preventDefault();

            self.sendFeedbackReport();
        });
    }

    sendFeedbackReport() {
        let self = this;

        // Show loading spinner
        self.feedbackDefault.classList.add('d-none');
        self.feedbackSubmitting.classList.remove('d-none');

        consultation.sections.forEach((section) => {
            if (section.slug !== consultation.contact_slug) {
                section.sub_sections.forEach((sub_section) => {
                    sub_section.groups.forEach((group) => {
                        group.questions.forEach((question) => {
                            self.buildFeedbackData(question);
                        })
                    });
                });
            } else {
                section.questions.forEach((question) => {
                    self.buildFeedbackData(question);
                });
            }
            
        });

        // for (const key of formData.keys()) {
        //     console.log(key);
        // }

        // for (const value of formData.values()) {
        //     console.log(value);
        // }

        
        let axiosInstance = axios.create({
            baseURL: process.env.FEEDBACK_BASE_URL,

            // API authentication
            headers: {
                'key': process.env.FEEDBACK_API_KEY,
                'secret': process.env.FEEDBACK_API_SECRET,
            }
        })

        axiosInstance
            .post(`/api/feedback-form/${process.env.FEEDBACK_MAP_ID}`, formData)
            .then((response) => {
                // Hide loading spinner
                self.feedbackDefault.classList.remove('d-none');
                self.feedbackSubmitting.classList.add('d-none');
                
                // Submit the form
                self.elem.submit();

                // Redirect to success
                window.location.replace(consultation.success_url);
                
                // Clear local storage if not local setup
                if (process.env.RELEASE_ENV != 'dev') {
                    localStorage.clear();
                }
            })
            .catch((error) => {
                self.feedbackErrorHandler(error)
            });
    }

    buildFeedbackData(question) {
        let question_value;
        let database_column = question.name.split("-").pop().trim();
        
        // Check for question key in local storage which is not null or empty array
        if (
            localStorage.getItem(question.name) &&
            (
                JSON.parse(localStorage.getItem(question.name)).value != '' ||
                JSON.parse(localStorage.getItem(question.name)).value.length
            )
        ) {
            if (Array.isArray(JSON.parse(localStorage.getItem(question.name)).value)) {
                question_value = JSON.parse(localStorage.getItem(question.name)).value.join(', ');
            } else {
                question_value = JSON.parse(localStorage.getItem(question.name)).value.trim();
            }
            
            // Add question data to FormData()
            formData.append((question.number ? `${question.number}-` : '') + database_column, question_value);
        }

        // Check if question has options (radio/checkbox)
        if (question.options) {
            if (localStorage.getItem(`${question.name}-options`) && localStorage.getItem(`${question.name}-options`).value != '') {
                question_value = JSON.parse(localStorage.getItem(`${question.name}-options`)).value.trim();

                // Add question data to FormData()
                formData.append((question.number ? `${question.number}-` : '') + database_column, question_value);
            }
        }

        // Check if question has additional questions
        if (question.additional_questions) {
            let additional_question_value;

            question.additional_questions.forEach((additional) => {
                if (localStorage.getItem(additional.name) && localStorage.getItem(additional.name).value != '') {
                    additional_question_value = JSON.parse(localStorage.getItem(additional.name)).value.trim();

                    // Add additional question data to FormData()
                    formData.append((question.number ? `${question.number}-` : '') + database_column + '-additional-' + additional.number, additional_question_value);
                }
            });
        }
    }

    // Show appropriate error message based on response
    feedbackErrorHandler(error) {
        let self = this;
        
        // Hide loading spinner
        self.feedbackDefault.classList.remove('d-none');
        self.feedbackSubmitting.classList.add('d-none');
        
        if (axios.isAxiosError(error)) {
            // Send error to Bugsnag
            Bugsnag.notify(error);
            
            // Declare error message to show to user
            let message = '';
                
            // Match error code to find message
            switch (error.code) {
                // No internet connection
                case 'ERR_NETWORK':
                    message = "Unable to connect to the server. Please check your internet connection and try again.";
                    break;
                // Page reloaded / lost connection
                case 'ERR_CANCELED':
                    message = "Your feedback submission was cancelled before it could complete. This may be due to your internet connection or the page was reloaded.";
                    break;
                // Fails server side field validation
                case 'ERR_BAD_REQUEST':
                    message = "We couldn't process your request because there seems to be an issue with the information provided. Please check all required fields and try again.";
                    break;
                // Otherwise...
                default:
                    message = "Sorry, there was an error trying to send your feedback, please check your submission and try again.";
            }
            // Append contact details to end of error message
            message = message + " If the problem persists contact us on " + consultation.contact_email;
            
            // Show error message to user
            self.formErrors.classList.remove('d-none');
            self.formErrors.innerHTML = message;
        }
    }

    // Convert carriage returns to line breaks for displaying textarea content in the table
    nl2br(str, is_xhtml) {
        if (typeof str === "undefined" || str === null) {
            return "";
        }

        let breakTag = is_xhtml || typeof is_xhtml === "undefined" ? "<br />" : "<br>";
        
        return (str + "").replace(
            /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
            "$1" + breakTag + "$2"
        );
    }
}

export default FeedbackReview;
